module.exports = __webpack_public_path__ + "img/index-1.9782311a.png";